import React from 'react';

import Image, { StaticImageData } from 'next/image';

import CartIcon from '@/assets/icons/Featured icon.svg';
import {
  IbmPlexItalic,
  IbmPlexItalicBold,
  IbmPlexItalicMedium,
  IbmPlexItalicSemiBold,
  SweetSansPro,
  SweetSansProBold,
  SweetSansProExtraLight,
  SweetSansProLight,
  SweetSansProMedium,
  SweetSansProSemiBold,
} from '@/config/fonts';
import cn from '@/helpers/utils/classNames';

import '@/styles/globals.v2.css';

export interface DeadStateProps {
  message?: string;
  title?: string;
  className?: string;
  icon?: string | StaticImageData;
  contentWrapperClassName?: string;
}

const DeadState = ({
  title = 'No Records Found.',
  message,
  icon = CartIcon,
  className,
  contentWrapperClassName,
}: DeadStateProps) => {
  return (
    <div
      className={cn(
        SweetSansProExtraLight.variable,
        SweetSansProLight.variable,
        SweetSansPro.variable,
        SweetSansProMedium.variable,
        SweetSansProSemiBold.variable,
        SweetSansProBold.variable,
        IbmPlexItalic.variable,
        IbmPlexItalicBold.variable,
        IbmPlexItalicMedium.variable,
        IbmPlexItalicSemiBold.variable,
        'comp-dead-state md:v2-w-[730px] md:v2-h-[550px] v2-w-[300px] v2-h-[300px] v2-mx-auto',
        className
      )}
    >
      <div className="v2-flex v2-items-center v2-h-full">
        <div className={cn('v2-mx-auto v2-pt-11 v2-text-center v2-max-w-[352px]', contentWrapperClassName)}>
          <Image src={icon} width={48} height={48} alt="" className="v2-mx-auto" />
          {title && (
            <h3 className="v2-font-sweet-sans-pro-semi-bold v2-font-semibold v2-text-gray-900 v2-text-base v2-leading-6 v2-mt-[10px]">
              {title}
            </h3>
          )}
          {message && (
            <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-[#475467] v2-text-sm v2-leading-5 v2-mt-1">
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeadState;
